var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('jm-table-filter',{attrs:{"type":_vm.type,"entities":_vm.entities},on:{"filtered":_vm.setFiltered}})],1),_vm._v(" "),_c('jm-table-view',{attrs:{"entities":_vm.filteredEntities,"view":_vm.view}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6924d89a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Entities.vue
// module id = null
// module chunks = 